import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GenericAuthService, GENERIC_AUTH_SERVICE_TOKEN } from '@nk/auth-lib';
import { AppService, AppFeatureService } from '@nk/access-block';
import { isNkHttpError } from '@nk/api-client-lib';

@Injectable()
export class IdentityGuardService {
  public identity: AppIdentityCompositeEntity;

  constructor(
    private _appService: AppService,
    private _appFeatureService: AppFeatureService,
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
  ) {}

  public canActivate(): Observable<boolean> {
    return this._appService.authValidCustomerIsChosen().pipe(
      map((validAuth) => {
        return !!validAuth;
      }),
      catchError((err: unknown) => {
        console.warn('ERR', err);
        if (isNkHttpError(err)) {
          this._authService.logout('custom', err.error.message);
        } else {
          this._authService.logout('custom');
        }
        return of(false);
      }),
    );
  }
}
